import { Items } from "./Items"
import { Map } from "./Map"

export const RecordMap = <V, NV>(
  input: Record<string, V>,
  keyFn: (value: V, key: string) => string,
  valueFn: (value: V, key: string) => NV
): Record<string, NV> =>
  Object.fromEntries(
    Map(([k, v]) => [keyFn(v as V, k), valueFn(v as V, k)], Items(input))
  ) as Record<string, NV>
